import { NetworkStatus, WatchQueryFetchPolicy } from "@apollo/client";
import { useMemo } from "react";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import { SearchInput } from "types/generated";

import { SEARCH_OPEN_TOFU_MIGRATION_QUEUE } from "./gql";

type UseOpenTofuMigrationSearchQueueProps = {
  variables: { input: SearchInput };
  pollingGroup: PollingIntervalGroups;
  nextFetchPolicy?: WatchQueryFetchPolicy;
};

const useOpenTofuMigrationSearchQueue = ({
  variables,
  pollingGroup,
  nextFetchPolicy,
}: UseOpenTofuMigrationSearchQueueProps) => {
  const { data, previousData, loading, error, refetch, networkStatus } = usePolledQuery(
    SEARCH_OPEN_TOFU_MIGRATION_QUEUE,
    { variables, pollingGroup, nextFetchPolicy }
  );

  const search = data?.openTofuMigrationQueueSearch || previousData?.openTofuMigrationQueueSearch;

  const entities = useMemo(() => search?.edges.map((edge) => edge.node) || [], [search?.edges]);

  return {
    entities,
    hasData: !!data,
    endCursor: data?.openTofuMigrationQueueSearch?.pageInfo.endCursor,
    startCursor: data?.openTofuMigrationQueueSearch?.pageInfo.startCursor,
    error,
    refetch,
    loadingContent:
      loading &&
      (networkStatus === NetworkStatus.loading || networkStatus === NetworkStatus.setVariables),
    isLoading: (loading && !search) || networkStatus === NetworkStatus.refetch,
  };
};

export default useOpenTofuMigrationSearchQueue;
